import ListView from "./ListView/ListView";

const CollectionPoint = () => <p>Collection Point</p>;

CollectionPoint.ListView = ListView;
export default CollectionPoint;
